import { PerfilAssinatura } from "eddydata-lib";
import { BaseResourceModel } from "../../models/base-resource.model";
import { AssinaturaEtapa } from "./assinatura-etapa.model";

export class AssinaturaEtapaPerfil extends BaseResourceModel {
    constructor(
        public id?: number,
        public ordem?: number,
        public certificado_digital?: boolean,
        public aguardar_assinatura?: boolean,
        public exigir_estoque?: boolean,
        public exigir_recurso?: boolean,
        public perfil?: PerfilAssinatura,
        public etapa?: AssinaturaEtapa,
        public parente?: AssinaturaEtapaPerfil

    ) {
        super();
    }

    static converteJson(json: any): AssinaturaEtapaPerfil {
        return Object.assign(new AssinaturaEtapaPerfil(), json);
    }
}
